import { supabase } from "../lib/supabase";

const STORAGE_KEY = "almoune_drivers";

export const defaultDrivers = [
  {
    id: 1,
    nom: "Chronopost",
    logo: "",
    delai: "Colis livré le lendemain matin avant 13h à votre domicile.",
    position: 1,
    phone: "",
    isActive: true,
  },
  {
    id: 2,
    nom: "Colissimo",
    logo: "",
    delai: "Livraison en 3 jours ouvrés, suivi inclus.",
    position: 2,
    phone: "",
    isActive: true,
  },
];

const readCache = () => {
  if (typeof window === "undefined") return [...defaultDrivers];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [...defaultDrivers];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [...defaultDrivers];
    if (!parsed.length) return [...defaultDrivers];
    return parsed;
  } catch {
    return [...defaultDrivers];
  }
};

const writeCache = (data) => {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch {}
  return data;
};

const nextId = (list) =>
  list.reduce((max, r) => Math.max(max, Number(r.id) || 0), 0) + 1;

const normalize = (row) => ({
  id: Number(row.id) || nextId(readCache()),
  nom: row.nom || row.name || "",
  name: row.name || row.nom || "",
  logo: row.logo || "",
  delai: row.delai || "",
  position: Number(row.position || 0) || 0,
  phone: row.phone || "",
  isActive: row.is_active !== undefined ? row.is_active : row.isActive !== undefined ? row.isActive : true,
  createdAt: row.created_at || row.createdAt || new Date().toISOString(),
});

export const loadDrivers = async () => {
  const cache = readCache();
  try {
    if (!supabase) return cache;
    const { data, error } = await supabase.from("drivers").select("*").order("created_at", { ascending: false });
    if (error) throw error;
    const rows = (data || []).map(normalize);
    writeCache(rows);
    return rows;
  } catch { return cache; }
};

export const saveDriver = async (driver) => {
  const normalized = normalize({
    id: driver.id ? Number(driver.id) : nextId(readCache()),
    nom: driver.nom || driver.name || "",
    logo: driver.logo || "",
    delai: driver.delai || "",
    position: Number(driver.position) || 0,
    phone: driver.phone || "",
    isActive: driver.isActive !== undefined ? driver.isActive : driver.is_active !== undefined ? driver.is_active : true,
  });
  const payload = {
    id: normalized.id,
    nom: normalized.nom,
    name: normalized.nom,
    logo: normalized.logo,
    delai: normalized.delai,
    position: normalized.position,
    phone: normalized.phone,
    is_active: normalized.isActive,
  };
  const cache = readCache();
  const idx = cache.findIndex((r) => Number(r.id) === normalized.id);
  if (idx >= 0) cache[idx] = { ...cache[idx], ...payload };
  else cache.push(payload);
  writeCache(cache);
  try {
    if (supabase) {
      const { error } = await supabase.from("drivers").upsert(payload, { onConflict: "id" });
      if (error) throw error;
    }
  } catch {}
  return normalized;
};

export const deleteDriver = async (id) => {
  const cache = readCache().filter((r) => Number(r.id) !== Number(id));
  writeCache(cache);
  try {
    if (supabase) {
      const { error } = await supabase.from("drivers").delete().eq("id", Number(id));
      if (error) throw error;
    }
  } catch {}
};

export const findDriverById = (id) => {
  const cache = readCache();
  return cache.find((d) => Number(d.id) === Number(id)) || null;
};
